var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBigSmileEmojiEmoticonEmoticonsEmotionExpressionSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 2050 2050",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffffff;}.cls-2{fill:#ffc500;}.cls-3{fill:#ff9f1e;}.cls-4{fill:#00305f;}.cls-5{fill:#ffe059;}.cls-6{fill:#fff1b8;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 2040,
    width: 2040,
    x: 5,
    y: 5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 3",
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1025,
    cy: 1025,
    r: 613.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1078,1577.1c-338.9,0-613.7-274.7-613.7-613.7A611,611,0,0,1,587.4,594.7C478.5,705.5,411.3,857.4,411.3,1025c0,338.9,274.8,613.7,613.7,613.7,200.6,0,378.6-96.2,490.6-245C1404.3,1506.9,1249.4,1577.1,1078,1577.1Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 773.9,
    cy: 863.1,
    rx: 94.9,
    ry: 60.2,
    transform: "translate(-121.9 1598.9) rotate(-87.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 803.6,
    cy: 824.5,
    r: 16.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 1276.1,
    cy: 863.1,
    rx: 60.2,
    ry: 94.9,
    transform: "translate(-36.2 56.1) rotate(-2.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1296.4,
    cy: 824.5,
    r: 16.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1025,1497.1A471.7,471.7,0,0,1,552.9,1025a30,30,0,0,1,60,0,412.1,412.1,0,1,0,824.2,0,30,30,0,0,1,60,0A471.7,471.7,0,0,1,1025,1497.1Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 602.3,
    cy: 1036.8,
    rx: 105.5,
    ry: 42.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 1447.7,
    cy: 1036.8,
    rx: 105.5,
    ry: 42.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1639.6,1024.9c0-339-274.7-613.7-613.7-613.7a610.8,610.8,0,0,0-281.4,68.2,665.3,665.3,0,0,1,431.7,23.2c-1.1,1.6-2.2,3.2-3.2,4.9-19.8,34.3,10.7,89,68.1,122.2,55.1,31.7,114.9,32.2,137.2,2,129.8,121,211,293.5,211,484.9a662.2,662.2,0,0,1-41.5,231.4A610.8,610.8,0,0,0,1639.6,1024.9Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 1110.5,
    cy: 541.1,
    rx: 24.8,
    ry: 41.5,
    transform: "matrix(0.5, -0.87, 0.87, 0.5, 86.69, 1232.27)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 1176.2,
    cy: 661.1,
    rx: 24.8,
    ry: 41.5,
    transform: "translate(-54.4 1214.2) rotate(-53.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1444.9,579.2h.2a614.3,614.3,0,0,0-214.8-131.2c-7.9,36.2,17.1,85.4,64.1,120.1C1351.1,610,1418.5,615,1444.9,579.2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigSmileEmojiEmoticonEmoticonsEmotionExpressionSvgrepoCom);
export default __webpack_public_path__ + "static/media/big-smile-emoji-emoticon-emoticons-emotion-expression-svgrepo-com.4b4070531e9a16e94184c9bb6dade5f1.svg";
export { ForwardRef as ReactComponent };